module.exports = __webpack_public_path__ + "img/consultant.7d49302e.jpg";